import React, { useEffect, useRef } from 'react';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import Chart from 'chart.js/auto';
import './RecruitmentDashboard.css';

const RecruitmentDashboard = () => {
  const openChartRef = useRef(null);
  const filledChartRef = useRef(null);
  const vendorChartRef = useRef(null);
  const timeChartRef = useRef(null);

  useEffect(() => {
    new Chart(openChartRef.current, {
      type: 'doughnut',
      data: {
        labels: ['Engineering/ Development', 'Sales', 'HR', 'Finance', 'Customer Support', 'Marketing'],
        datasets: [{
          data: [10, 4, 2, 1, 12, 3],
          backgroundColor: ['#fbbf24', '#a78bfa', '#60a5fa', '#99f6e4', '#fde68a', '#f472b6']
        }]
      }
    });

    new Chart(filledChartRef.current, {
      // type: 'doughnut',
      data: {
        labels: ['Engineering/ Development', 'Sales', 'HR', 'Finance', 'Customer Support', 'Marketing'],
        datasets: [{
          data: [2, 2, 1, 0, 3, 1],
          backgroundColor: ['#fbbf24', '#a78bfa', '#60a5fa', '#99f6e4', '#fde68a', '#f472b6']
        }]
      }
    });

    new Chart(vendorChartRef.current, {
      type: 'bar',
      data: {
        labels: ['Vendor 1', 'Vendor 2', 'Vendor 3', 'Vendor 4', 'Vendor 5', 'Vendor 6'],
        datasets: [{
          label: 'Contributions',
          data: [90, 30, 65, 85, 60, 60],
          backgroundColor: '#3b82f6'
        }]
      }
    });

    new Chart(timeChartRef.current, {
      type: 'bar',
      data: {
        labels: ['Engineering', 'HR', 'Sales', 'Finance', 'Customer Support', 'Marketing'],
        datasets: [{
          label: 'Avg. Days',
          data: [30, 5, 15, 12, 10, 8],
          backgroundColor: '#a78bfa'
        }]
      }
    });
  }, []);

  return (
    <Container fluid className="dashboard-container">
      {/* Pie Charts */}
      <Row>
        <Col md="6">
          <Card className="dashboard-card">
            <CardBody>
              <div className="dashboard-title">Total Open Positions (Department Wise)</div>
              <canvas ref={openChartRef}></canvas>
            </CardBody>
          </Card>
        </Col>
        <Col md="6">
          <Card className="dashboard-card">
            <CardBody>
              <div className="dashboard-title">Total Filled Positions</div>
              <canvas ref={filledChartRef}></canvas>
            </CardBody>
          </Card>
        </Col>
      </Row>

      {/* Bar Charts */}
      <Row>
        <Col md="6">
          <Card className="dashboard-card">
            <CardBody>
              <div className="dashboard-title">Vendor Contribution</div>
              <canvas ref={vendorChartRef}></canvas>
            </CardBody>
          </Card>
        </Col>
        <Col md="6">
          <Card className="dashboard-card">
            <CardBody>
              <div className="dashboard-title">Average Time to Hire (Department Wise)</div>
              <canvas ref={timeChartRef}></canvas>
            </CardBody>
          </Card>
        </Col>
      </Row>

      {/* KPI Cards */}
      <Row className="kpi-row">
        <Col md="4">
          <Card className="dashboard-card text-center">
            <CardBody>
              <div className="kpi">Offer Acceptance Rate<div className="kpi-label">80%</div></div>
            </CardBody>
          </Card>
        </Col>
        <Col md="4">
          <Card className="dashboard-card text-center">
            <CardBody>
              <div className="kpi">Candidate Drop-off Rate<div className="kpi-label">20%</div></div>
            </CardBody>
          </Card>
        </Col>
        <Col md="4">
          <Card className="dashboard-card text-center">
            <CardBody>
              <div className="kpi">Total Vendors<div className="kpi-label">6</div></div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default RecruitmentDashboard;